<template>
  <div
    class="reward"
    :class="[item.customClass]"
  >
    <div
      v-if="item.img"
      class="reward-img"
    >
      <img :src="item.img" />
      <div
        v-if="item.num !== undefined"
        class="reward-num"
        :class="numPosition"
        :data-txt="item.num"
      >
        {{ item.num }}
      </div>
    </div>

    <slot>
      <div
        v-if="item.amt !== undefined"
        class="reward-amt"
        :data-txt="item.amt"
      >
        {{ item.amt }}
      </div>
      <div
        v-if="item.bottom !== undefined"
        class="reward-bottom"
        :data-txt="item.bottom"
      >
        {{ item.bottom }}
      </div>
    </slot>
  </div>
</template>

<script>
export default {
  name: 'RewardItem',
  props: {
    item: {
      type: Object,
      required: true,
    },
    numPosition: {
      type: String,
      default: 'bottom-end',
    },
  },
}
</script>

<style lang="scss">
.reward {
  text-align: center;

  &-list {
    display: flex;
    flex-wrap: wrap;

    &--column {
      flex-direction: column;
      flex-wrap: nowrap;
      gap: 12px;
    }
  }

  // 主列表和详情列表共用同一个组件，仅通过修饰类改变排列方向。
  &--detail {
    display: flex;
    gap: 12px;
    align-items: center;
    text-align: left;

    .reward-img {
      flex: 0 0 64px;
      width: 64px;
      height: 64px;
    }
  }

  &-img {
    position: relative;

    img {
      max-width: 100%;
      max-height: 100%;
      object-fit: contain;
    }
  }

  &-num {
    position: absolute;
    color: #fff;
    text-shadow: -1px -1px 1px #000, 1px -1px 1px #000, -1px 1px 1px #000, 1px 1px 1px #000;

    &[class*="end"],
    &[class*="right"] {
      right: 0;
    }

    &[class*="end"],
    &[class*="bottom"] {
      bottom: 0;
    }

    &.top,
    &.bottom {
      width: 100%;
      text-align: center;
    }
  }

  &-info {
    min-width: 0;
  }

  &-name {
    font-weight: 700;
  }

  &-desc {
    margin-top: 4px;
  }
}
</style>
